// Baked in at build time by vue.config.js; compared against the deployed public/version.json.
export const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;

export async function fetchDeployedVersion() {
  try {
    const url = (process.env.BASE_URL || "/") + "version.json?t=" + Date.now();
    const response = await fetch(url, {
      cache: "no-store",
      headers: { "Cache-Control": "no-cache", Pragma: "no-cache" }
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data && data.version ? data.version : null;
  } catch (e) {
    return null;
  }
}

export async function isOutOfDate() {
  if (!BUILD_VERSION) return false;
  const deployed = await fetchDeployedVersion();
  if (!deployed) return false;
  return deployed !== BUILD_VERSION;
}
